var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FC470E",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11.5 2.875A8.627 8.627 0 0 0 2.875 11.5a8.627 8.627 0 0 0 8.625 8.625 8.627 8.627 0 0 0 8.625-8.625A8.627 8.627 0 0 0 11.5 2.875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FC470E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.5 5.75v6.469h4.313"
  })));
};
export default SvgTime;